import { render, staticRenderFns } from "./filter-sort.vue?vue&type=template&id=39d95c92"
import script from "./filter-sort.vue?vue&type=script&lang=js"
export * from "./filter-sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports